<mat-card>
  <mat-card-title>{{conjugationClass.label}}</mat-card-title>
  <mat-card-content (click)="showDetails($event)" >{{conjugationClass.content}}</mat-card-content>
</mat-card>
